import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import StoreController, {
  CouponType,
  CurrentStoreContext,
} from '../../../controller/StoreController';
import { useToast } from '../../../controller/ToastController';
import ConfirmModal from '../../../components/modal/ConfirmModal';

const CouponIndex = () => {
  const showToast = useToast();
  const navigate = useNavigate();
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const [couponList, setCouponList] = useState<CouponType[]>([]);
  const [isOpen, setIsOpen] = useState<boolean[]>([]);

  const [selectedCouponId, setSelectedCouponId] = useState<number>(-1);
  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);

  const navigateCouponInfo = () => {
    navigate(`/product/coupon/edit`);
  };

  const openConfirmModal = (couponId: number) => {
    setVisibleConfirm(true);
    setSelectedCouponId(couponId);
  };

  // API 호출
  const getCouponData = async () => {
    try {
      const oRes = await StoreController.getCoupon(currentStore.value); // test

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getCoupon', oResponse);
        if (oResponse.data) {
          setCouponList([...oResponse.data]);
          setIsOpen(new Array(oResponse.data.length).fill(true));
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const deleteCouponData = async () => {
    try {
      const oRes = await StoreController.delCoupon(selectedCouponId);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('delCoupon', oResponse);
        if (oResponse.data && oResponse.ok) {
          showToast('쿠폰을 삭제했어요');
          getCouponData();
        }
      }
      setVisibleConfirm(false);
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    getCouponData();
  }, []);

  interface DraggableItemProps {
    item: CouponType;
    index: number;
  }

  const RenderCoupon = ({ item, index }: DraggableItemProps) => {
    const changeIsOpen = () => {
      const dataTemp = isOpen;
      dataTemp[index] = !dataTemp[index];
      setIsOpen([...dataTemp]);
    };

    return (
      <div key={index}>
        <div className={`listItem ${isOpen[index] && 'open'}`}>
          <div className="row gap">
            <div className="indexBox">{index + 1}</div>
            <h3>{item.coupon_name}</h3>
          </div>
          <div className="row gap">
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_trashcan.svg`}
              alt="ic"
              onClick={() => openConfirmModal(item.coupon_id)}
            />
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_arrow_${
                isOpen[index] ? 'up' : 'down'
              }_grey.svg`}
              onClick={changeIsOpen}
              width={30}
              height={30}
              alt="ic"
            />
          </div>
        </div>
        {isOpen[index] && (
          <div className="menuList">
            <div className="menuSideWrap">
              <div className="row between">
                <h4>{item.coupon_type === 0 ? '할인금액' : '할인률'}</h4>
                <h4>
                  {item.coupon_type === 0
                    ? `${item.price!.toLocaleString()}원`
                    : `${item.percent}%`}
                </h4>
              </div>
              <div className="row between">
                <h4>최소주문금액</h4>
                <h4>{item.requirement.toLocaleString()}원</h4>
              </div>
              {item.coupon_type === 1 && (
                <div className="row between">
                  <h4>최대할인금액</h4>
                  <h4>{item.max_discount!.toLocaleString()}원</h4>
                </div>
              )}
            </div>
            <div className="menuSideWrap noneBorder">
              <div className="row between">
                <h4>최대쿠폰발행수</h4>
                <h4>
                  {item.is_count_limit === 0
                    ? '제한 없음'
                    : `${item.count_limit!.toLocaleString()}개`}
                </h4>
              </div>
              <div className="row between">
                <h4>다운받은 고객수</h4>
                <h4>{item.count_sent.toLocaleString()}명</h4>
              </div>
              <div className="row between">
                <h4>사용기간</h4>
                <h4>
                  {moment(new Date(item.start_date)).format('YYYY/MM/DD')}-
                  {moment(new Date(item.end_date)).format('YYYY/MM/DD')}
                </h4>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <Style>
        <div className="contentContainer">
          <button className="addButton" onClick={() => navigateCouponInfo()}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
            <h4>새 쿠폰 추가하기</h4>
          </button>

          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
            <div>
              <p>숫자를 입력하거나 숫자 버튼을 드래그 해서 순서를 변경해주세요.</p>
            </div>
          </div>

          {couponList.length > 0 ? (
            <div className="categoryList">
              {couponList.map((item: CouponType, index: number) => {
                return <RenderCoupon key={index} item={item} index={index} />;
              })}
            </div>
          ) : (
            <div className="noneWrap">
              <h3>상품분류를 등록해주세요</h3>
            </div>
          )}
        </div>
      </Style>
      <ConfirmModal
        isOpen={visibleConfirm}
        title={`삭제 후 복구할 수 없습니다.\n정말 삭제하시겠어요?`}
        onCancelText="취소"
        onConfirmText="삭제"
        onCancel={() => setVisibleConfirm(false)}
        onConfirm={deleteCouponData}
      />
    </>
  );
};

export default CouponIndex;

const Style = styled.div`
  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  input {
    width: 100%;
    padding: 10px 12px 10px 30px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
  input::placeholder {
    color: #cecece;
  }

  .addButton {
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin-bottom: 10px;

    h4 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  .categoryList {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 30px;

    .listItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px 10px 22px;
      background: #ecf5f3;
      border: 1px solid #ecf5f3;
      border-radius: 5px;

      .indexBox {
        width: 30px;
        height: 30px;
        padding: 4px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        text-align: center;
        color: #40977f;
        background: #ecf5f3;
        border: 1px solid #4dd2ae;
        border-radius: 4px;
      }

      .row {
        gap: 6px;
      }
      .row.gap {
        gap: 14px;
      }
      h3 {
        color: #555555;
        font-weight: 600;
      }

      .loadButton {
        display: flex;
        align-items: center;
        border: 1px solid #4dd2ae;
        border-radius: 5px;
        padding: 4px 9px;
        gap: 4px;

        h5 {
          color: #40977f;
          font-weight: 600;
        }
      }
    }
    .listItem.open {
      border-radius: 5px 5px 0 0;
    }

    .menuList {
      display: flex;
      border: 1px solid #e5e5e5;
      border-top: none;
      border-radius: 0 0 5px 5px;
      .menuSideWrap {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 20px;
        border-right: 1px solid #e5e5e5;

        h4 {
          font-size: 16px;
          line-height: 22px;
          font-weight: 500;
          color: #555555;
        }
      }
      .menuSideWrap.noneBorder {
        border-right: none;
      }
    }
  }

  @media (max-width: 600px) {
    .row.between {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;
